import { createContext } from "react"

/*
 * Table context to be used on any level
 */
export const tableContext = createContext({ loading: true })
export const LEFT = "left"
export const RIGHT = "right"
export const CENTER = "center"
export const COLLAPSIBLE_NONE = "none"
export const COLLAPSIBLE_COLS = "cols"
export const COLLAPSIBLE_ROWS = "rows"
export const SCROLLABLE_NONE = "none"
export const SCROLLABLE_Y = "vertically"
export const SCROLLABLE_X = "horizontally"
export const SCROLLABLE_BOTH = "both"
